

import { newformatApi } from '@/api/baseApi';

// 根据关键字拉取员工信息
export async function newSearchStaffList(v, Limit) {
  const result = await newformatApi({
    Action: 'Get',
    Method: 'StaffInfo',
    SystemId: '2',
    Keyword: v,
    Limit: parseInt(Limit, 10),

  });
  const { data } = result;
  return data.data;
}